(function () {
  'use strict';

  function slugify(value) {
    return value
      .toLowerCase()
      .trim()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '') || 'section';
  }

  function createTocItem(heading) {
    var item = document.createElement('li');
    var link = document.createElement('a');

    item.dataset.level = heading.tagName === 'H3' ? '3' : '2';
    link.href = '#' + heading.id;
    link.textContent = heading.textContent.trim();
    item.appendChild(link);

    return item;
  }

  function prepareArticleContent(root) {
    var content = root.querySelector('[data-bpg-content]');
    if (!content) return [];

    content.querySelectorAll('h1').forEach(function (heading) {
      var replacement = document.createElement('h2');
      Array.prototype.slice.call(heading.attributes).forEach(function (attribute) {
        replacement.setAttribute(attribute.name, attribute.value);
      });
      replacement.innerHTML = heading.innerHTML;
      heading.replaceWith(replacement);
    });

    var usedIds = new Set();
    var headings = Array.prototype.slice.call(content.querySelectorAll('h2, h3'));

    headings.forEach(function (heading) {
      var baseId = heading.id ? slugify(heading.id) : slugify(heading.textContent);
      var uniqueId = baseId;
      var index = 2;

      while (usedIds.has(uniqueId) || (document.getElementById(uniqueId) && document.getElementById(uniqueId) !== heading)) {
        uniqueId = baseId + '-' + index;
        index += 1;
      }

      usedIds.add(uniqueId);
      heading.id = uniqueId;
    });

    content.querySelectorAll('table').forEach(function (table) {
      if (table.parentElement && table.parentElement.classList.contains('bpg-table-scroll')) return;
      var wrapper = document.createElement('div');
      wrapper.className = 'bpg-table-scroll';
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    });

    content.querySelectorAll('iframe, video').forEach(function (media) {
      if (media.closest('.bpg-responsive-embed')) return;
      var width = Number(media.getAttribute('width'));
      var height = Number(media.getAttribute('height'));
      var isWide = !width || !height || width / height >= 1.3;
      if (!isWide) return;

      var wrapper = document.createElement('div');
      wrapper.className = 'bpg-responsive-embed';
      media.parentNode.insertBefore(wrapper, media);
      wrapper.appendChild(media);
    });

    content.querySelectorAll('img').forEach(function (image) {
      if (!image.hasAttribute('loading')) image.loading = 'lazy';
      if (!image.hasAttribute('decoding')) image.decoding = 'async';
    });

    content.querySelectorAll('a[target="_blank"]').forEach(function (link) {
      var rel = (link.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
      ['noopener', 'noreferrer'].forEach(function (value) {
        if (rel.indexOf(value) === -1) rel.push(value);
      });
      link.setAttribute('rel', rel.join(' '));
    });

    return headings;
  }

  function buildToc(root, headings) {
    if (headings.length < 2) return;

    var desktopCard = root.querySelector('[data-bpg-toc-card]');
    var desktopList = root.querySelector('[data-bpg-toc-list]');
    var mobileToc = root.querySelector('[data-bpg-mobile-toc]');
    var mobileList = root.querySelector('[data-bpg-mobile-toc-list]');

    headings.forEach(function (heading) {
      if (desktopList) desktopList.appendChild(createTocItem(heading));
      if (mobileList) mobileList.appendChild(createTocItem(heading));
    });

    if (desktopCard) desktopCard.hidden = false;
    if (mobileToc) mobileToc.hidden = false;

    var links = Array.prototype.slice.call(
      root.querySelectorAll('[data-bpg-toc-list] a, [data-bpg-mobile-toc-list] a')
    );

    links.forEach(function (link) {
      link.addEventListener('click', function () {
        var mobileDetails = link.closest('details');
        if (mobileDetails) mobileDetails.open = false;
      });
    });

    if (!('IntersectionObserver' in window)) return;

    var activeId = '';
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) activeId = entry.target.id;
        });

        links.forEach(function (link) {
          link.classList.toggle('is-active', link.getAttribute('href') === '#' + activeId);
        });
      },
      {
        rootMargin: '-20% 0px -70% 0px',
        threshold: 0
      }
    );

    headings.forEach(function (heading) {
      observer.observe(heading);
    });
  }

  function setupCopyLink(root) {
    var button = root.querySelector('[data-bpg-copy-link]');
    if (!button) return;

    button.addEventListener('click', function () {
      var originalLabel = button.dataset.copyLabel || 'Copy link';
      var copiedLabel = button.dataset.copiedLabel || 'Copied';

      function showSuccess() {
        button.textContent = copiedLabel;
        window.setTimeout(function () {
          button.textContent = originalLabel;
        }, 1800);
      }

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(window.location.href).then(showSuccess).catch(function () {});
        return;
      }

      var field = document.createElement('textarea');
      field.value = window.location.href;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.opacity = '0';
      document.body.appendChild(field);
      field.select();

      try {
        document.execCommand('copy');
        showSuccess();
      } catch (error) {
        // No visible error is needed for this optional enhancement.
      }

      document.body.removeChild(field);
    });
  }

  function setupProgress(root) {
    var progress = document.querySelector('[data-bpg-progress] span');
    var content = root.querySelector('[data-bpg-content]');
    if (!progress || !content) return;

    var ticking = false;

    function update() {
      var rect = content.getBoundingClientRect();
      var start = window.scrollY + rect.top - window.innerHeight * 0.2;
      var end = start + content.offsetHeight - window.innerHeight * 0.65;
      var current = window.scrollY;
      var percent = end > start ? ((current - start) / (end - start)) * 100 : 0;
      percent = Math.max(0, Math.min(100, percent));
      progress.style.width = percent + '%';
      ticking = false;
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    update();
  }

  function initialize(root) {
    if (!root || root.dataset.bpgInitialized === 'true') return;
    root.dataset.bpgInitialized = 'true';

    var headings = prepareArticleContent(root);
    buildToc(root, headings);
    setupCopyLink(root);
    setupProgress(root);
  }

  function initializeAll(scope) {
    (scope || document).querySelectorAll('[data-bpg-article]').forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeAll(document);
    });
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
})();
